import { Box, BoxProps, Icon, Text, TextProps } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, useCallback, useEffect, useRef, useState } from 'react'
import { Button } from '../comps/Button'
import Footer from '../comps/Footer'
import { useStores } from '../data/store'
import { isIFrame, sendErrorIfNotIframe } from '../utils'
import { errorMessage, errorTitle, pages, REDIRECTION_DELAY } from '../utils/constants'

const ErrorView: FC = ({ route }: any) => {
  const { intentId, redirectUrl } = useStores((root) => ({
    intentId: root.transaction.id.intentId,
    redirectUrl: root.transaction.initiatingEntity.returnUrl,
  }))
  const navigation = useNavigation()
  const { message: errMessage = errorMessage, title = errorTitle, rUrl } = route?.params ?? {}
  console.log('errorview ~ errMessage', errMessage)
  const [timeLeft, setTimeLeft] = useState(REDIRECTION_DELAY)
  const infoText = `You will be redirected to merchant's page in ${timeLeft <= 0 ? 0 : timeLeft} seconds...`
  const timeLeftRef = useRef<any>()
  useEffect(() => {
    timeLeftRef.current = setInterval(() => setTimeLeft((currentTimeLeft) => currentTimeLeft - 1), 1000)
    setTimeout(() => {
      clearInterval(timeLeftRef.current)
      if (isIFrame()) {
        window.parent.postMessage(
          {
            txnId: 0,
            intentId,
            status: 'error',
            message: errMessage,
          },
          '*',
        )
      } else {
        console.log('HTAG', 'ERROR IN')
        sendErrorIfNotIframe('error', errMessage, redirectUrl, intentId)
      }
    }, REDIRECTION_DELAY * 1000)
  }, [errMessage, intentId, redirectUrl])

  const handleButton = () => {
    if (rUrl) {
      //Linking.openURL(rUrl)
      window.location.href = rUrl
    } else {
      navigation.reset({
        index: 0,
        routes: [{ name: pages.payment }],
      })
      // navigate(pages.payment)
    }
  }

  const navigateToMerchant = useCallback(
    (returl: string) => {
      timeLeftRef.current = setInterval(() => setTimeLeft((currentTimeLeft) => currentTimeLeft - 1), 1000)
      setTimeout(() => {
        clearInterval(timeLeftRef.current)
        if (isIFrame()) {
          window.parent.postMessage(
            {
              txnId: 0,
              intentId,
              status: 'error',
              message: errorMessage,
            },
            '*',
          )
        } else {
          // Linking.openURL(returl)
          window.location.href = returl
        }
      }, REDIRECTION_DELAY * 1000)
    },
    [intentId],
  )

  useEffect(() => {
    if (rUrl) {
      navigateToMerchant(rUrl)
    }
  }, [navigateToMerchant, rUrl])

  const buttonTitle = rUrl ? 'Go Back To Merchant' : 'Retry'

  return (
    <Box {...styles.containerView}>
      <Box {...styles.contentView}>
        <Icon id="STATUS_FAILED" color="ERROR" size={40} />
        <Box {...styles.paymentStatusContainer}>
          <Text {...styles.statusMessage}>{title}</Text>
          <Text {...styles.titleText}>{errMessage}</Text>
          {!!rUrl && <Text {...styles.titleText}>{infoText}</Text>}
        </Box>
        {rUrl && (
          <Box {...styles.payBtn}>
            <Button title={buttonTitle} onPress={handleButton} />
          </Box>
        )}
      </Box>
      <Footer isBottomAligned={true} />
    </Box>
  )
}

const styles = {
  containerView: {
    padding: 16,
    backgroundColor: 'LIGHT_GREY_SEPARATOR',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    zIndex: 100,
  } as BoxProps,
  contentView: {
    marginTop: 16,
    alignItems: 'center',
    maxWidth: 330,
  } as BoxProps,
  payBtn: { alignItems: 'center', justifyContent: 'center', marginTop: 16 } as BoxProps,
  paymentStatusContainer: { marginVertical: 8, alignItems: 'center', width: '100%' } as BoxProps,
  statusMessage: {
    paddingVertical: 4,
    color: 'BLACK_75',
    fontSize: 24,
    fontWeight: '500',
    letterSpacing: 0,
    textAlign: 'center',
    fontFamily: 'jioType-medium',
  } as TextProps,
  infoText: {
    paddingVertical: 4,
    color: 'DARK_GREY',
    fontSize: 12,
    fontWeight: '500',
    letterSpacing: 0,
    fontFamily: 'jioType-medium',
  } as TextProps,
  titleText: {
    color: 'BLACK_75',
    textAlign: 'center',
    fontSize: 12,
    fontWeight: '700',
    fontFamily: 'jioType-medium',
  } as TextProps,
  valueText: {
    marginTop: 4,
    color: 'DARK_GREY',
    fontSize: 16,
    fontWeight: '500',
    fontFamily: 'jioType-medium',
  } as TextProps,
}

export default ErrorView
